/** 
 * @type {import("./defs").StoreProjectFinancials} 
 */
const store = {
}
/** 
* @returns {import("./defs").StoreProjectFinancials} 
*/
export default function () {
    return JSON.parse(JSON.stringify(store));
}


// WEBPACK FOOTER //
// ./resources/js/storers/StoreProjectFinancials.js